module.exports = __webpack_public_path__ + "static/media/plage.729d9669.jpeg";